import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { APIError } from "../../components/APIError";

import { ColumnHead } from "../../components/CustomTableComponents/ColumnHead";
import { LoadingRow } from "../../components/CustomTableComponents/LoadingRow";
import { PaymentDetails } from "../../api/services";
import { useAccountPayments } from "./hooks/useAccountPayments";
import { PaymentRow } from "./components/PaymentRow";
import { CustomPaginatedTableContainer } from "../../components/CustomTableComponents";

export const Payments: React.FC = () => {
  const { accountNumber } = useParams();
  const {
    page,
    pageSize,
    setPage,
    count,
    data: payments,
    status,
    error,
  } = useAccountPayments(accountNumber);

  return (
    <>
      <Helmet>
        <title>{accountNumber} - Account Financials: Payments</title>
      </Helmet>
      {error ? (
        <APIError title="We could not load payments for this account." />
      ) : (
        <CustomPaginatedTableContainer
          maxWidth="768px"
          width="100%"
          paginationProps={{
            page,
            pageSize,
            count,
            setPage,
          }}
        >
          <Table>
            <TableHead data-testid="Payments__TableHead">
              <TableRow>
                <ColumnHead boxProps={{ width: "128px" }}>Date</ColumnHead>
                <ColumnHead boxProps={{ width: "256px" }}>
                  Payment Method
                </ColumnHead>
                <ColumnHead>Reference</ColumnHead>
                <ColumnHead boxProps={{ width: "128px", textAlign: "right" }}>
                  Credit
                </ColumnHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {status === "loading" ? (
                <LoadingRow col={4} />
              ) : payments && payments.length > 0 ? (
                payments!.map((payment: PaymentDetails) => (
                  <PaymentRow payment={payment} key={payment.id} />
                ))
              ) : (
                payments && (
                  <TableRow>
                    <TableCell colSpan={4}>
                      No payments for this account.
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </CustomPaginatedTableContainer>
      )}
    </>
  );
};
